<template>
  <div>
    <div class="top">班级缴费进度</div>
    <div class="contaa">   
      <div class="top2">
        <div class="toptitle">
          缴费结果<span class="numdata">（共{{ numdata }}条）</span>
        </div>
        <div v-if="datalist.length > 0">
          <div
            class="single"
            v-for="item in datalist"
            :key="item.id"
            @click="tonewpage(item)"
          >
            <van-cell :title="item.title" is-link></van-cell>
            <!-- <div class="one">
              <span>单价:{{ (item.summary.fee / 100).toFixed(2) }}元</span>
            </div> -->
            <div class="one">
              <span>应缴费学生:{{ item.summary.student_count }}人</span
              ><span>已缴费学生:{{ item.summary.student_count_paid }}人</span>
            </div>
            <div class="one">
              <span
                >应收费:{{ (item.summary.total_fee / 100).toFixed(2) }}元</span
              ><span
                >已收费:{{
                  (item.summary.total_fee_paid / 100).toFixed(2)
                }}元</span
              >
            </div>
          </div>
        </div>
        <div v-else>
          <van-empty description="暂无数据" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subdata: {},
      showtime: false,
      showschool: false,
      showclass: false,
      datalist: [],
      numdata: 0,
      subdata: {},
      columns: [],
      showschool: false,
      cascaderValue: "",
      show: false,
      showimfo: {},
      fieldNames: {
        text: "title",
        value: "key",
        children: "children",
      },
    };
  },

  mounted() {
    this.searchpay();
  },

  methods: {
    tonewpage(value) {
      this.$router.push({ path: "/hisimfo", query: { id: value.id,title: value.title} });
    },
    showPopup(value) {
      this.show = true;
      this.showimfo = value;
    },
    searchpay() {
      this.payitems = [];
      this.fetchget("/api/app/payment",{WithSummary:true}).then((res) => {
        if (res.code < 0) {
          this.$notify({
            type: "danger",
            message: res.msg,
            color: "#ad0000",
            background: "#ffe1e1",
          });
        } else {
          console.log(res);
          this.numdata = res.totalCount;
          this.datalist = res.items;
        }
      });
    },
    onFinish({ selectedOptions }) {
      this.showschool = false;
      let fieldValue = [];
      selectedOptions.map((option) => fieldValue.push(option));
      if (fieldValue.length > 1) {
        this.subdata.class =
          fieldValue[fieldValue.length - 2].title +
          fieldValue[fieldValue.length - 1].title;
      } else if (fieldValue.length == 1) {
        this.subdata.class = fieldValue[fieldValue.length - 1].title;
      }
      this.orid = fieldValue[fieldValue.length - 1].value;
      console.log(this.subdata, 777);
    },
   
  },
};
</script>

<style lang="scss" scoped>
$brand: #dd0000;
$bg: #f3f5f9;
$text: #0f172a;
$border: #e2e8f0;
$radius: 10px;
$shadow: 0 4px 16px rgba(15, 23, 42, 0.06);

.one {
  line-height: 30px;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  font-weight: normal;
  padding: 0 16px;
  color: #475569;
}

.contaa {
  overflow-y: auto;
  min-height: calc(100vh - 44px);
  padding: 14px;
  background: $bg;
  box-sizing: border-box;
}

.top {
  width: 100%;
  height: 44px;
  background-color: $brand;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 44px;
  letter-spacing: 1px;
  color: #ffffff;
}

.top2 {
  width: 100%;

  .toptitle {
    width: 100%;
    box-sizing: border-box;
    min-height: 40px;
    text-align: left;
    color: $text;
    font-size: 15px;
    font-weight: 600;
    line-height: 40px;
    border-bottom: 1px solid $border;
    background-color: #ffffff;
    padding: 0 16px;
    margin-bottom: 12px;
    border-radius: $radius $radius 0 0;

    .numdata {
      font-weight: 400;
      letter-spacing: 1px;
      color: #64748b;
      font-size: 14px;
    }
  }

  .single {
    margin-bottom: 12px;
    color: $text;
    font-size: 14px;
    font-weight: 600;
    background-color: #ffffff;
    padding: 0 0 8px;
    border-radius: $radius;
    border: 1px solid $border;
    box-shadow: $shadow;
    overflow: hidden;
  }

  .price {
    color: $brand;
    font-size: 14px;
    font-weight: 600;
  }
}
</style>